export enum KanbanPassengerDragSlotEnum {
  Grip = "Grip",
  Restriction = "Restriction",
  Placeholder = "Placeholder",
}
